module.exports = function getResource(label, vars = []) {
    let resources = {
        availabletimes: 'Heures de disponibilité',
        noTimesAvailable: 'Pas d’heures disponibles',
        for: 'pour',
        waitlist: 'Liste d’attente'
    };

    return resources[label];
};
